import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_URL } from './api';

function LoyaltyValidationScreen() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [customer, setCustomer] = useState({
    firstName: '',
    lastName: '',
    birthDate: '',
    email: '',
    phone: '',
  });

  const hasToken = useMemo(() => token.length > 0, [token]);

  useEffect(() => {
    let mounted = true;

    const fetchCustomer = async () => {
      if (!hasToken) {
        setError('Lien de validation manquant.');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/loyalty/validate/${encodeURIComponent(token)}`);
        const payload = await response.json();
        if (!response.ok) {
          throw new Error(payload.error || 'Lien de validation invalide.');
        }

        if (!mounted) {
          return;
        }

        setCustomer({
          firstName: payload.firstName || '',
          lastName: payload.lastName || '',
          birthDate: payload.birthDate || '',
          email: payload.email || '',
          phone: payload.phone || '',
        });
      } catch (fetchError) {
        if (mounted) {
          setError(fetchError.message);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchCustomer();
    return () => {
      mounted = false;
    };
  }, [hasToken, token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${API_URL}/api/loyalty/validate/${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(customer),
      });
      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload.error || 'Impossible de valider le compte.');
      }

      setSuccess('Merci pour votre fidélité ! Vous recevrez des bon cadeaux de notre restaurant par sms');
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="loyalty-entry-page">
      <div className="loyalty-entry-card">
        <span className="kiosk-eyebrow">Fidelisation</span>
        <h1>Valide ton compte</h1>
        <p>Complète tes informations pour finaliser ton inscription.</p>

        {loading ? (
          <div className="kiosk-loading" style={{ minHeight: 180 }}>Chargement du compte...</div>
        ) : success ? (
          <div className="admin-summary-card">{success}</div>
        ) : (
          <form className="loyalty-validation-form" onSubmit={handleSubmit}>
            <div className="admin-form-grid admin-form-grid-2">
              <label className="admin-field">
                <span>Prénom</span>
                <input
                  type="text"
                  value={customer.firstName}
                  onChange={(event) => setCustomer((prev) => ({ ...prev, firstName: event.target.value }))}
                />
              </label>
              <label className="admin-field">
                <span>Nom</span>
                <input
                  type="text"
                  value={customer.lastName}
                  onChange={(event) => setCustomer((prev) => ({ ...prev, lastName: event.target.value }))}
                />
              </label>
            </div>
            <div className="admin-form-grid admin-form-grid-2">
              <label className="admin-field">
                <span>Date de naissance</span>
                <input
                  type="date"
                  value={customer.birthDate}
                  onChange={(event) => setCustomer((prev) => ({ ...prev, birthDate: event.target.value }))}
                />
              </label>
              <label className="admin-field">
                <span>Email</span>
                <input
                  type="email"
                  value={customer.email}
                  onChange={(event) => setCustomer((prev) => ({ ...prev, email: event.target.value }))}
                />
              </label>
            </div>

            {error && <div className="loyalty-entry-error">{error}</div>}

            <div className="loyalty-entry-actions loyalty-entry-actions-inline">
              <button type="submit" className="kiosk-cta" disabled={saving}>
                {saving ? 'Validation...' : 'Valider le compte'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default LoyaltyValidationScreen;
